/* eslint-disable */
ace.define('ace/snippets/python', ['require', 'exports', 'module'], function (e, t, n) {
  'use strict'
  t.snippetText = 'snippet print\n' +
                  '\tprint(${1:string})\n' +
                  'snippet import\n' +
                  '\timport ${1:module}\n' +
                  'snippet from\n' +
                  '\tfrom ${1:package} import ${2:module}\n' +
                  '# Module Docstring\n' +
                  'snippet docs\n' +
                  '\t\\\'\\\'\\\'\n' +
                  '\tFile: ${1:FILENAME:file_name}\n' +
                  '\tAuthor: ${2:author}\n' +
                  '\tDescription: ${3}\n' +
                  '\t\\\'\\\'\\\'\n' +
                  'snippet while\n' +
                  '\twhile ${1:condition}:\n' +
                  '\t\t${2:# TODO: write code...}\n' +
                  'snippet with\n' +
                  '\twith ${1:expr} as ${2:var}:\n' +
                  '\t\t${3:# TODO: write code...}\n' +
                  '# New Class\n' +
                  'snippet class\n' +
                  '\tclass ${1:ClassName}(${2:object}):\n' +
                  '\t\t"""${3:docstring for $1}"""\n' +
                  '\t\tdef __init__(self, ${4:arg}):\n' +
                  '\t\t\t${5:super($1, self).__init__()}\n' +
                  '\t\t\tself.$4 = $4\n' +
                  '\t\t\t${6}\n' +
                  '# New Function\n' +
                  'snippet def\n' +
                  '\tdef ${1:fname}():\n' +
                  '\t\t${2:# TODO: write code...}\n' +
                  '\n' +
                  '# Ifs\n' +
                  'snippet if\n' +
                  '\tif ${1:condition}:\n' +
                  '\t\t${2:# TODO: write code...}\n' +
                  'snippet el\n' +
                  '\telse:\n' +
                  '\t\t${1:# TODO: write code...}\n' +
                  'snippet ei\n' +
                  '\telif ${1:condition}:\n' +
                  '\t\t${2:# TODO: write code...}\n' +
                  '# For\n' +
                  'snippet for\n' +
                  '\tfor ${1:item} in ${2:items}:\n' +
                  '\t\t${3:# TODO: write code...}\n' +
                  '# Encodes\n' +
                  'snippet cutf8\n' +
                  '\t# -*- coding: utf-8 -*-\n' +
                  '\n' +
                  '# Lambda\n' +
                  'snippet ld\n' +
                  '\t${1:var} = lambda ${2:vars} : ${3:action}\n' +
                  '\n' +
                  'snippet try Try/Except\n' +
                  '\ttry:\n' +
                  '\t\t${1:# TODO: write code...}\n' +
                  '\texcept ${2:Exception}, ${3:e}:\n' +
                  '\t\t${4:raise $3}\n' +
                  'snippet try Try/Except/Else\n' +
                  '\ttry:\n' +
                  '\t\t${1:# TODO: write code...}\n' +
                  '\texcept ${2:Exception}, ${3:e}:\n' +
                  '\t\t${4:raise $3}\n' +
                  '\telse:\n' +
                  '\t\t${5:# TODO: write code...}\n' +
                  'snippet try Try/Except/Finally\n' +
                  '\ttry:\n' +
                  '\t\t${1:# TODO: write code...}\n' +
                  '\texcept ${2:Exception}, ${3:e}:\n' +
                  '\t\t${4:raise $3}\n' +
                  '\tfinally:\n' +
                  '\t\t${5:# TODO: write code...}\n' +
                  'snippet try Try/Except/Else/Finally\n' +
                  '\ttry:\n' +
                  '\t\t${1:# TODO: write code...}\n' +
                  '\texcept ${2:Exception}, ${3:e}:\n' +
                  '\t\t${4:raise $3}\n' +
                  '\telse:\n' +
                  '\t\t${5:# TODO: write code...}\n' +
                  '\tfinally:\n' +
                  '\t\t${6:# TODO: write code...}\n' +
                  '# if __name__ == \\\'__main__\\\':\n' +
                  'snippet ifmain\n' +
                  '\tif __name__ == \\\'__main__\\\':\n' +
                  '\t\t${1:main()}\n' +
                  '# __magic__\n' +
                  'snippet _\n' +
                  '\t__${1:init}__${2}\n' +
                  '# python debugger (pdb)\n', t.scope = 'python'
})
